import React from 'react'
import PropTypes from 'prop-types'
import './contact-form2.css'

const ContactForm2 = ({ heading1, content1, children, rootClassName = '' }) => (
  <section className={`contact-form2-thq-contact5-elm thq-section-padding ${rootClassName}`}>
    <div className="contact-form2-inner thq-section-max-width">
      <h2 className="thq-heading-2">{heading1 || 'Apply To Join'}</h2>
      <p className="thq-body-large contact-form2-text1">
        {content1 || 'We handpick players for our server to create the best community that we possibly can.'}
      </p>
      {children}
    </div>
  </section>
)

ContactForm2.propTypes = {
  rootClassName: PropTypes.string,
  content1: PropTypes.node,
  heading1: PropTypes.node,
  children: PropTypes.node,
}

export default ContactForm2
